import axios from '@/plugins/axios'

const statistics = {
  namespaced: true,
  state: {
    data: {}
  },
  actions: {
    get({ commit }, params) {
      axios.get('/statistics/', { params })
        .then(({ data }) => {
          commit('updateData', data)
        })
    }
  },
  mutations: {
    updateData(state, data) {
      state.data = data
    }
  }
}

export default statistics
